export const PAGINATION_SIZE = 10;
/** Products loaded per page on the products page */
export const PRODUCTS_PAGE_SIZE = 12;
export const DEFAULT_GRID_IMG_LOAD_EAGER_COUNT = 4;
export const ATTR_LOADING_EAGER = 'eager';

export const DEFAULT_COUNTRY_CODE = 'AU';
export const DEFAULT_PHONE_CODE = '+61';
export const DEFAULT_PHONE_ERROR_MESSAGE = `Please enter a valid ${DEFAULT_PHONE_CODE} mobile number`;
export const DEFAULT_TURNSTILE_ERROR_MESSAGE =
  'Verification is required. Please ensure you have completed the verification below.';

export function getImageLoadingPriority(index: number, maxEagerLoadCount = DEFAULT_GRID_IMG_LOAD_EAGER_COUNT) {
  return index < maxEagerLoadCount ? ATTR_LOADING_EAGER : undefined;
}

export const SUPPORT_EMAIL = 'info@leafio.com.au';

export const CUSTOMER_ACCOUNT_SESSION_KEY = 'customerAccount';

export const DEBOUNCE_MS = 300;

export const DEFAULT_DATE_FORMAT = 'dd/MM/yy';

export const USER_REGISTRATION_VERIFIED_TAG = 'APPROVED';

export const DRAFT_PARAM = 'draft';
